import { MasterQuestionConfig } from "../questionnaires/questionnaireConfig/models";

import * as questionIds from "./questionIds";

export const masterConfig: MasterQuestionConfig[] = [
    // Referral Outcome Report
    {
        id: questionIds.EmployeeId,
        questionText: "Employee Unique Id",
        canBeDisabled: false
    },
    {
        id: questionIds.JustificationForEqualityActOpinion,
        questionText: "Justification for Equality Act Opinion",
        canBeDisabled: false
    }
];
